"use client"

import { signIn } from "next-auth/react"
import { Icon, Typography } from "@/shared/ui/atoms"
import { CustomButton } from "@/shared/ui/molecules"
import { useSearchParams } from "next/navigation"
import { normalizeSafeInternalRedirect } from "@/shared/lib/safe-redirect"
interface SnsSignInButtonProps {
  icon: string
  text: string
  type: "facebook" | "google" | "naver" | "kakao"
}

const SnsSignInButton = ({ icon, text, type }: SnsSignInButtonProps) => {
  const redirectUrl = useSearchParams()?.get("redirect")
  const handleSnsSignIn = () => {
    signIn(type, {
      callbackUrl: normalizeSafeInternalRedirect(redirectUrl) || "/ko",
    })
  }

  const buttonClassName = () => {
    switch (type) {
      case "facebook":
        return "w-full py-[14px] flex items-center justify-center gap-2 rounded-lg border-[1px] border-[#E5E7EB] bg-[#1877F2]"
      case "naver":
        return "w-full py-[14px] flex items-center justify-center gap-2 rounded-lg border-[1px] border-[#E5E7EB] bg-[#03C75A]"
      case "kakao":
        return "w-full py-[14px] flex items-center justify-center gap-2 rounded-lg border-[1px] border-[#E5E7EB] bg-[#FEE500]"
      default:
        return "w-full py-[14px] flex items-center justify-center gap-2 rounded-lg border-[1px] border-[#E5E7EB] bg-[#F9FAFB]"
    }
  }

  const textClassName = () => {
    switch (type) {
      case "facebook":
        return "text-medium text-center text-white font-semibold"
      case "naver":
        return "text-medium text-center text-white font-semibold"
      case "kakao":
        return "text-medium text-center text-[#111827] font-semibold"
      default:
        return "text-medium text-center text-[#111827] font-semibold"
    }
  }

  return (
    <CustomButton className={buttonClassName()} onClick={handleSnsSignIn}>
      <Icon src={icon} alt={type} width={24} />
      <Typography size={18} lineHeight={26} className={textClassName()}>
        {text}
      </Typography>
    </CustomButton>
  )
}

export default SnsSignInButton
